export enum PourMethod {
  '2PMP' = '2PMP',
  'BUCK' = 'BUCK',
  'C' = 'C',
  'CHUT' = 'CHUT',
  'COLM' = 'COLM',
  'CNCL' = 'CNCL',
  'CRAN' = 'CRAN',
  'ACCS' = 'ACCS',
  'XPLT' = 'XPLT',
  'EXCA' = 'EXCA',
  'KERB' = 'KERB',
  'HOLE' = 'HOLE',
  'BFIL' = 'BFIL',
  'BOOM' = 'BOOM',
  'B' = 'B',
  'LINE' = 'LINE',
  'L' = 'L',
  'SPRY' = 'SPRY',
  'WB' = 'WB',
}

export function formatPourMethod(method: PourMethod) {
  const mappings = {
    '2PMP': '2 Pumps',
    'BUCK': 'Bucket',
    'C': 'Chute',
    'CHUT': 'Chute',
    'COLM': 'Columns',
    'CNCL': 'Council Works',
    'CRAN': 'Crane & Kibble',
    'ACCS': 'Difficult Access',
    'XPLT': 'Ex-Plant',
    'EXCA': 'Excavator',
    'KERB': 'Kerb',
    'HOLE': 'Post Holes',
    'BFIL': 'Blockfill Pump',
    'BOOM': 'Boom Pump',
    'B': 'Boom Pump',
    'LINE': 'Line Pump',
    'L': 'Line Pump',
    'SPRY': 'Spray Pump',
    'WB': 'Wheelbarrow',
  }
  return mappings[method]
}
